import {AxiosRequestConfig, CancelTokenSource, Method, RawAxiosRequestHeaders} from "axios";

export enum APIActionType {
    FETCH_INIT,
    FETCH_SUCCESS,
    FETCH_FAILURE,
    DATA_UPDATE
}

export interface APIAction<T> {
    type: APIActionType;
    payload?: T;
    statusCode?: number;
}

export interface StrapiErrorResponse {
    error: {
        status: number;
        name: string;
        message: string;
        details?: Record<string, unknown>;
    },
    data?: Record<string, unknown>;
  }

export interface APIState<T> {
    isLoading: boolean;
    isError: boolean;
    statusCode?: number;
    data?: T;
    errorData?: StrapiErrorResponse;
    cancelToken: CancelTokenSource | null;
}

export interface FetchRequestStruct<T> {
    url?: string;
    data?: T;
    config?: Omit<AxiosRequestConfig, "headers"> & {headers?: RawAxiosRequestHeaders};
    method?: Method;
    callback?: Function;
    cache?: boolean;//> set false to disable,
    throttle?: boolean;//> set false to disable
}
export type fetchRequest<T> = FetchRequestStruct<T> | null | string | undefined;

export const isStrapiErrorResponse = (data: any): data is StrapiErrorResponse => {
	return "data" in data
        && data?.error
        && typeof data?.error?.message === "string"
        && typeof data?.error?.status === "number";
}